<template>
  <div v-loading="loading">
    <div class="detail_echart_top">
      <div
        class="detail_top_item"
        v-for="(item, index) in gridList"
        :key="index"
      >
        <div class="detail_top_item_title">{{ item.value | FormatNum }}</div>
        <div class="detail_top_item_value">{{ item.label }}</div>
      </div>
    </div>
    <div class="detail_echart_con">
      <div class="table_header">
        <div class="table_header_title">
          {{ $t("Relationship.RelatedCompanies") }}
        </div>
        <div class="table_header_menus">
          <el-select
            clearable
            v-model="searchCompany"
            filterable
            class="search-select-con"
            popper-class="new-search-select"
            :popper-append-to-body="true"
            :placeholder="$t('Relationship.Entercompanyname')"
            @change="selectCompany"
            no-match-text="The Subject company has no affiliation with the inquired company."
          >
            <el-option
              v-for="(item, index) in companyList"
              :key="index"
              :label="item.name"
              :value="item.id"
            >
              <OverflowTooltip :tip="item.name" />
            </el-option>
          </el-select>
        </div>
      </div>
      <div class="detail_echart_con_box">
        <!-- 关系图 -->
        <div class="detail_echart_d3">
          <RelationshipD3
            ref="d3Ref"
            :relationshipSearch="relationshipSearch"
            :chartData="relationshipChartData"
          />
        </div>
      </div>
    </div>
    <div class="detail_echart_table">
      <div class="table_header">
        <div class="table_header_title">
          {{ $t("Relationship.RelatedCompanies") }}
        </div>
      </div>
      <el-table
        class="risk_table"
        :data="tableData"
        height="100%"
        ref="tableRef"
        :row-key="(row) => row.aaaId"
      >
        <el-table-column
          prop="name"
          :label="$t('Relationship.Name')"
          min-width="200"
        >
          <template slot-scope="scope">
            <div class="flex_center_start_box">
              <!-- <span class="link_hover_text" @click="goDetail(scope.row)">
                {{ scope.row.name }}</span
              > -->
              <span
                class="link_hover_text"
                v-if="
                  scope.row.id3a
                    .split('')
                    .every((char) => char >= '0' && char <= '9')
                "
                @click="goDetail(scope.row)"
              >
                {{ scope.row.name }}</span
              >
              <span v-else>
                {{ scope.row.name }}
              </span>
            </div>
          </template>
        </el-table-column>
        <el-table-column
          prop="country"
          align="center"
          :label="$t('Relationship.Country')"
          min-width="100"
        >
        </el-table-column>
        <el-table-column
          prop="location"
          align="center"
          :label="$t('Relationship.Location')"
          min-width="110"
        >
        </el-table-column>
        <el-table-column
          prop="type"
          :label="$t('Relationship.Type')"
          align="center"
          min-width="145"
        >
        </el-table-column>
        <el-table-column
          prop="shares"
          align="center"
          :label="$t('Relationship.Shares')"
          min-width="120"
        >
        </el-table-column>
        <el-table-column
          prop="relations"
          align="center"
          :label="$t('Relationship.Relationship')"
          min-width="100"
        >
        </el-table-column>
      </el-table>
      <div class="pagination_box">
        <Page
          :keyword="$t('Relationship.RelatedCompanies')"
          :fontColor="'#B44818'"
          :total="total"
          :pageSize="searchParams.pageSize"
          :currentPage="searchParams.currentPage"
          @onPageChange="onChangePage"
        ></Page>
      </div>
    </div>

    <Tips :dialogVisible.sync="isShowTips"></Tips>
  </div>
</template>
<script>
import { mixins1 } from "@/mixins/index";
import Page from "@/views/newLayout/page.vue";
import EquityD3 from "@/views/company/details/Background/componet/index.vue";
import RelationshipD3 from "./Com_Relationship-d3.vue";
import Tips from "@/views/newLayout/tips.vue";
import { getRelateChart, getCompanyRelationInquiry } from "@/api/uboApi.js";
import { getCompanies, getRelatedSummary } from "@/api/companyApi.js";
import {
  formatterTxt,
  formatListMax50,
} from "@/views/company/details/Background/utils";

export default {
  name: "UboDetail4",
  mixins: [mixins1],
  components: {
    Page,
    EquityD3,
    Tips,
    RelationshipD3,
  },

  data() {
    return {
      loading: false,
      isShowTips: false,
      isShowD3: false,
      total: 0,
      searchParams: {
        currentPage: 1,
        pageSize: 5,
      },
      gridList: [
        { label: this.$t("Relationship.TotalEntities"), value: "-" },
        // { label: this.$t("Relationship.Entities"), value: "-" },
        { label: this.$t("Relationship.Subsidiaries"), value: "-" },
        
        { label: this.$t("Relationship.Branches"), value: "-" },
        { label: this.$t("Relationship.RelatedCompanies"), value: "-" },
        { label: this.$t("Relationship.Countries"), value: "-" },
      ],
      tableData: [],

      relationshipChartData: {},

      searchCompany: "",
      companyList: [],
      relationshipSearch: [
        { label: this.$t("Relationship.RelationType"), value: "-" },
        { label: this.$t("Relationship.RelationLevel"), value: "-" },
      ],
    };
  },
  methods: {
    changeSwitch(val) {
      this.isShowD3 = val;
    },
    onChangePage(param) {
      this.searchParams.currentPage = param.page;
      this.searchParams.pageSize = param.pageSize;
      this.getCompanyRelated();
    },
    // 跳转ubo详细
    goDetail(row) {
      let routeData = this.$router.resolve({
        path: "/ubo/detail",
        query: {
          id3a: row.id3a,
          keyword: row.name,
          selectKey: "Company",
        },
      });
      window.open(routeData.href, "_blank");
    },
    getShareholderSummaryList() {
      getRelatedSummary({ id3a: this.$route.query.id3a }).then((res) => {
        if (res.code == 200) {
          this.gridList = [
            {
              label: this.$t("Relationship.TotalEntities"),
              value: res.data.total || "-",
            },
            // {
            //   label: this.$t("Relationship.Entities"),
            //   value: res.data.entities || "-",
            // },

            {
              label: this.$t("Relationship.Subsidiaries"),
              value: res.data.persons || "-",
            },
           
            {
              label: this.$t("Relationship.Branches"),
              value: res.data.branches || "-",
            },
            {
              label: this.$t("Relationship.RelatedCompanies"),
              value: res.data.relatedCompanies || "-",
            },
             {
              label: this.$t("Relationship.Countries"),
              value: res.data.countries || "-",
            },
          ];
        }
      });
    },

    // 点状关系图
    getRelateChartApi() {
      this.loading = true;
      getRelateChart({
        aaaid: this.$route.query.id3a,
      })
        .then((res) => {
          this.relationshipChartData = res.data;
          this.companyList = res.data.nodes.filter(
            (node) => node.nodeType === "Company",
          );
        })
        .catch((err) => {})
        .finally(() => {
          this.loading = false;
        });
    },
    getCompanyRelated() {
      let param = {
        id3a: this.$route.query.id3a,
        page: this.searchParams.currentPage,
        pageSize: this.searchParams.pageSize,
      };
      getCompanies(param).then((res) => {
        if (res.code == 200) {
          this.tableData = res.data.rows;
          this.total = res.data.total;
        }
      });
    },

    // 查询关系
    async getRelationshipApi(node) {
      let params = {
        targetCompany: this.$route.query.id3a,
        queriedCompany: node.aaaid,
      };
      let res = await getCompanyRelationInquiry(params);
      if (res.code == 200) {
        this.relationshipSearch = [
          {
            label: this.$t("Relationship.RelationType"),
            value: res.data.relationType || "-",
          },
          {
            label: this.$t("Relationship.RelationLevel"),
            value: res.data.relationLevel || "-",
          },
        ];
      }
    },

    // 查询公司
    selectCompany(val) {
      const selectedNode = this.relationshipChartData.nodes.find(
        (node) => node.id === val,
      );
      console.log("Selected Node:", selectedNode);
      if (selectedNode) {
        this.getRelationshipApi(selectedNode).then(() => {
          this.$refs.d3Ref.highlightNode(selectedNode, true);
          this.$refs.d3Ref.ishowSearchDetail = true;
        });
      }
    },
  },
  mounted() {
    this.getRelateChartApi();
    this.getShareholderSummaryList();
    this.getCompanyRelated();
  },
};
</script>
<style scoped>
.risk_table >>> .el-table__body-wrapper {
  height: 100% !important;
}
.table_header_title {
  color: rgb(96, 60, 44);
}
</style>
